// store/modules/box/actions.js
import BoxApi from "../../../api/modules/BoxApi";
import util from '../../../util'

const searchAvailableBoxes = (_, payload) => {
  return BoxApi.searchAvailableBoxes(payload.context, payload.idClient, payload.process, payload);
};

const loadRecentBoxes = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.get('/boxes/recent/' + payload.idClient + '/' + payload.type, {headers}).then((response) => {
      commit('setBoxes', {boxes: response.data.boxes})
      commit('setCountBoxes', response.data.count)
      resolve(response.data)
    }).catch(error => {
      util.showDialogError(payload.context, 'Ocurrió un error al cargar las cajas.')
      reject(error)
    });
  })
};

const loadBoxesInClient = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.get(`/boxes/paged/client/${payload.idClient}/inclient?${[payload.params]}`, {headers})
      .then(response => {
        resolve({
          content: response.data.content,
          totalElements: response.data.totalElements
        });
      })
      .catch(error => {
        util.showDialogError(payload.context, 'Ocurrió un error al cargar las cajas.')
        reject(error)
      })
  });

}

const searchBoxesBulk = async ({commit}, payload) => {
  try {
    const {context, idClient, type, file} = payload;

    return await BoxApi.searchBoxesBulk(context, {idClient, type, file});
  } catch (error) {
    console.error("Error en búsqueda masiva de cajas:", error);
    throw error;
  }
};

export default {
  searchAvailableBoxes,
  loadRecentBoxes,
  loadBoxesInClient,
  searchBoxesBulk,
};



// WEBPACK FOOTER //
// ./src/store/modules/boxes/actions.js